module.exports = __webpack_public_path__ + "img/sousuo.1ec61af4.svg";